import { createHazardScoreBadge } from '../ScoreBadge'

const riskRatingPalette: Record<number, string> = {
  1: '#a0ce63',
  2: '#eaa443',
  3: '#ea3323',
  4: '#757171',
  5: '#494949',
}

export const scoreColor = riskRatingPalette

export const scoreTextColor = {
  1: 'black',
  2: 'black',
  3: 'white',
  4: 'white',
  5: 'white',
}

export function getRating(score: number | null): string {
  if (typeof score !== 'number' || Number.isNaN(score)) {
    return '-'
  }
  const scoreInt = Math.round(score)
  return _scoreToRating?.[scoreInt] ?? '-'
}

export function getRiskRatingColor(score: number | null | undefined): string {
  if (typeof score !== 'number' || Number.isNaN(score)) return '#9e9e9e'
  const normalized = Math.min(Math.max(Math.round(score), 1), 5)
  return riskRatingPalette[normalized] ?? '#9e9e9e'
}

const _scoreToRating: { [key: number]: string } = {
  1: 'Low',
  2: 'Moderate',
  3: 'Moderate to High',
  4: 'High',
  5: 'Very High',
}

const floodLabels = _scoreToRating

export const FloodScoreBadge = createHazardScoreBadge({
  labels: floodLabels,
  // palette: riskRatingPalette,
})

export default scoreColor
